import { SuggestedFaqsContainer } from '@/modules/SuggestedFaq';

export const SuggestedFaqs = (): JSX.Element => <SuggestedFaqsContainer />;

export default SuggestedFaqs;
